import { callService, niceCheck } from "@Views/utils/ServiceUtils";
import { isEmpty, sha256 } from "@Views/utils/StringUtils";
import { useRef, useState } from "react";
import { useHistory } from "react-router";
import sendIcon from '@Images/icon-send.png';

const PwdFindPage1 = ({ msg, history, setPwdFindPageNo, setUserEmail }: any) => {

    const idRef: any = useRef();
    const emailRef: any = useRef();

    const OSUUD04R01 = async (param: any) => {
        return await callService('OSUUD04R01', param);
    }

    const OBMUD01U06 = async (usrId: string) => {

        var param = {
            usrId: usrId,
            usrTypCd: 'OB'
        }

        return await callService('OBMUD01U06', param);
    }

    const OSUUD06R01 = async (info: any) => {

        return await callService("OSUUD06R01", info)
    }

    const onPwdCheck = async () => {

        const usrId = idRef['current']['value'];
        const usrEmail = emailRef['current']['value'];

        if (isEmpty(usrId) || isEmpty(usrEmail)) {
            alert("아이디, E-mail은 필수 입력항목 입니다.");
            return;
        } else {

            const regExpEmail = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
            if (!regExpEmail.test(usrEmail)) {
                alert('이메일 형식이 아닙니다.');
                return;
            }

            const param = {

                usrId: usrId,
                usrTypCd: 'OB',
                cntctEaddr: usrEmail,
                useYn: 'Y',
                lginUseYn: 'Y'
            }

            const res = await OSUUD04R01(param);

            if (res['sucsYn'] === 'Y') {

                await OBMUD01U06(usrId);

                setPwdFindPageNo(3);
                setUserEmail(res['cntctEaddr']);
            } else {
                setPwdFindPageNo(2);
            }
        }

    }

    return (
        <>
            <div className="wrap-body-center set-default">
                <div className="bg"></div>
                <div className="find-wrap">
                    <div className="find">
                        <div className="find-tit">
                            <h2>{msg['findAccount']}</h2>
                        </div>
                        <div className="find-content">
                            <div className="find-tab">
                                <button type="button" className="btn" onClick={() => history.push('/IdFind')}>{msg['findId']}</button>
                                <button type="button" className="btn active">{msg['findPwd']}</button>
                            </div>
                            <div className="find-act-wrap">
                                <div className="find-txt">
                                    <h3>{msg['findPwdTitle']}</h3>
                                    <p className="sub-txt" dangerouslySetInnerHTML={{ __html: msg['findPwdDesc'] }}></p>
                                </div>
                                <div className="find-form">
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box">
                                                <input className="form-control" type="text" id="text" placeholder={msg['idPlaceholder']} ref={idRef} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-box-group">
                                            <div className="input-box">
                                                <input className="form-control" type="email" id="email" placeholder={msg['emailPlaceholder']} ref={emailRef} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="result-btn">
                                        <button type="reset" className="btn btn-popup negative" onClick={() => history.push('/Login')}>{msg['cancel']}</button>
                                        <button type="submit" className="btn btn-popup positive" onClick={() => onPwdCheck()}>{msg['confirm']}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const PwdFindPage2 = ({ msg, history }: any) => {

    const signInClick = () => {
        niceCheck('/SignIn');
    }

    return (
        <>
            <div className="wrap-body-center set-default">
                <div className="bg"></div>
                <div className="find-wrap">
                    <div className="find">
                        <div className="find-tit">
                            <h2>{msg['findAccount']}</h2>
                        </div>
                        <div className="find-content">
                            <div className="find-tab">
                                <button type="button" className="btn" onClick={() => history.push('/IdFind')}>{msg['findId']}</button>
                                <button type="button" className="btn active">{msg['findPwd']}</button>
                            </div>
                            <div className="find-act-wrap">
                                <div className="find-txt">
                                    <h3>{msg['pwdCheck']}</h3>
                                    <p className="sub-txt">{msg['pwdCheckDesc']}</p>
                                </div>
                                <div className="find-result">
                                    <div className="result-txt">
                                        <p>{msg['pwdCheckFailMsg']}</p>
                                    </div>
                                    <div className="result-btn">
                                        <a className="btn btn-popup negative" tabIndex={0} onKeyUp={(e) => (e.code === 'Space' || e.code === 'Enter') && history.push('/')} onClick={() => history.push('/')}>{msg['main']} </a>
                                        <a className="btn btn-popup positive" tabIndex={0} onKeyUp={(e) => (e.code === 'Space' || e.code === 'Enter') && history.push('/Signin')} onClick={signInClick}>{msg['singIn']}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const PwdFindPage3 = ({ msg, history, userEmail }: any) => {
    return (
        <>
            <div className="wrap-body-center set-default">
                <div className="bg"></div>
                <div className="find-wrap">
                    <div className="find">
                        <div className="find-tit">
                            <h2>{msg['findAccount']}</h2>
                        </div>
                        <div className="find-content">
                            <div className="find-tab">
                                <button type="button" className="btn" onClick={() => history.push('/IdFind')}>{msg['findId']}</button>
                                <button type="button" className="btn active">{msg['findPwd']}</button>
                            </div>
                            <div className="find-act-wrap">
                                <div className="find-txt">
                                    <h3>{msg['sendPwd']}</h3>
                                    <p className="sub-txt" dangerouslySetInnerHTML={{ __html: msg['sendPwdDesc'] }}></p>
                                </div>
                                <div className="find-result">
                                    <div className="result-txt send-txt">
                                        <div className="send-icon">
                                            <img src={sendIcon} alt="이메일전송이 완료되었습니다." />
                                        </div>
                                        <p>
                                            {msg['sendMsg1']}<span>[{userEmail}]</span>{msg['sendMsg2']}<br />{msg['sendPwdMsg']}
                                        </p>
                                    </div>
                                    <div className="result-btn">
                                        <div className="result-btn">
                                            <a className="btn btn-popup negative" tabIndex={0} onKeyUp={(e) => (e.code === 'Space' || e.code === 'Enter') && history.push('/')} onClick={() => history.push('/')}>{msg['main']}</a>
                                            <a className="btn btn-popup positive" tabIndex={0} onKeyUp={(e) => (e.code === 'Space' || e.code === 'Enter') && history.push('/Login')} onClick={() => history.push('/Login')}>{msg['login']}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const PasswordFind = ({ msg }: any) => {
    const history = useHistory();
    const [pwdFindPageNo, setPwdFindPageNo] = useState<number>(1);
    const [userEmail, setUserEmail] = useState<string>();

    const getPwdFind = () => {

        if (pwdFindPageNo === 1) {
            return <PwdFindPage1 msg={msg} history={history} setPwdFindPageNo={setPwdFindPageNo} setUserEmail={setUserEmail} />
        } else if (pwdFindPageNo === 2) {
            return <PwdFindPage2 msg={msg} history={history} />
        } else if (pwdFindPageNo === 3) {
            return <PwdFindPage3 msg={msg} history={history} userEmail={userEmail} />
        }

    }

    return (
        <>
            {
                getPwdFind()
            }
        </>
    );
}
export default PasswordFind;